// db-site









// ready

$(document).ready(function () {










var $pdpOptions = $('.pdp-color-options');

if ($pdpOptions.length) {

    // ADD CLASS TO MAIN PDP WRAPPER
    var $main = $('.wt-product__main');

    if ($main.length) {
      $main.addClass('has-color-options');
    }

    // 1. REMOVE SHOPIFY <br>
    if ($pdpOptions.find('br').length) {
      $pdpOptions.find('br').remove();
    }

    // 2. MOVE COLOR OPTIONS OUT OF RTE
    var $rte = $pdpOptions.closest('.wt-product__text-block.rte');
    if ($rte.length) {
      //$pdpOptions.insertAfter($rte);
    }

    var currentPath = window.location.pathname;
    var $label = $pdpOptions.find('.pdp-swatch-label__color-name');

    // 3. SET CURRENT BASED ON URL
    $pdpOptions.find('.pdp__variant').each(function () {
      var $item = $(this);
      var variant = $item.data('variant');

      if (currentPath.indexOf(variant) !== -1) {
        $pdpOptions.find('.pdp__variant').removeClass('is-current');
        $item.addClass('is-current');
      }
    });

    // 4. SET INITIAL LABEL
    var currentColor = $pdpOptions.find('.pdp__variant.is-current').data('color-value');

    if (currentColor) {
      $label.text(currentColor);
    }

    // 5. HOVER BEHAVIOR
    $pdpOptions.find('.pdp__variant').hover(
      function () {
        var hoverColor = $(this).data('color-value');
        if (hoverColor) {
          $label.text(hoverColor);
        }
      },
      function () {
        var resetColor = $pdpOptions.find('.pdp__variant.is-current').data('color-value');
        if (resetColor) {
          $label.text(resetColor);
        }
      }
    );

}



// add class to options

$('.wt-product__option').each(function () {

  var $option = $(this);
  var $label = $option.find('.label');

  if ($label.length) {

    var labelText = $label.text().toLowerCase();

    if (labelText.indexOf('color') !== -1) {
      $option.addClass('wt-product__option--color');
    }

    if (labelText.indexOf('size') !== -1) {
      $option.addClass('wt-product__option--size');
    }

  }

});







// target blank

if ($('.wt-footer__list').length) {

    $('.wt-footer__list a').each(function () {

        var href = $(this).attr('href') || '';

        if (
            href.indexOf('instagram.com') > -1 ||
            href.indexOf('facebook.com') > -1 ||
            href.indexOf('fb.com') > -1 ||
            href.indexOf('tiktok.com') > -1 ||
            href.indexOf('pinterest.com') > -1 ||
            href.indexOf('youtube.com') > -1 ||
            href.indexOf('youtu.be') > -1 ||
            href.indexOf('twitter.com') > -1 ||
            href.indexOf('x.com') > -1 ||
            href.indexOf('linkedin.com') > -1 ||
            href.indexOf('threads.net') > -1 ||
            href.indexOf('snapchat.com') > -1 ||
            href.indexOf('reddit.com') > -1 ||
            href.indexOf('discord.gg') > -1 ||
            href.indexOf('discord.com') > -1
        ) {

            $(this).attr('target', '_blank');
            $(this).attr('rel', 'noopener noreferrer');

        }

    });

}






// target blank

$("a.target-blank").each(function() {
	$(this).addClass('lock');
	$(this).attr("target", "_blank");
});













}); // doc ready







